var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.successMessage)?_c('div',{staticClass:"alert alert-success alert-dismissible"},[_c('b-link',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close"}},[_vm._v("\n    ×\n  ")]),_c('strong',[_vm._v(_vm._s(_vm.successMessage))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }